import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Component } from '@angular/core';
import { OrdersService } from '@app/services/order/orders.service';
import { ToastrService } from 'ngx-toastr';
import { TicketComponent } from '@app/components/ticket/ticket.component';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { Router } from '@angular/router';

@Component({
  selector: 'orders',
  templateUrl: 'orders.component.html',
  styleUrls: ['orders.component.scss'],
})
export class OrdersComponent {
  pdvs: any[] = [];
  pdv: string = "";
  modalRef: BsModalRef;
  dtOptions: any = {};
  rule: boolean = false;
  rule1: boolean = false;
  rulesLabel: String = "MODIFIER COMMANDE";
  rulesLabel1: String = "CREER COMMANDE";
  orders: any[] = [];
  ticket = false;
  order: any = {};
  idOrder2: number = 0;
  user: any = {};
  date: Number;
  enablePayement = false;
  subs: Subscription;

  constructor(
    private toastr: ToastrService,
    private modalService: BsModalService,
    private ordersService: OrdersService,
    private webSiteUsersService: WebSiteUsersService,
    private router: Router,
  ) {
    this.getUserOrders();
  }


  getReadyin(d, minDelay) {
    let date = +new Date();
    let dateCmd = +new Date(d);
    var tmp = Math.floor((date - dateCmd) / 60000);
    tmp = (minDelay - tmp > 0) ? minDelay - tmp : 0;
    return tmp;
  }

  ngOnInit() {
    this.subs = this.ordersService.enablePayement.subscribe(
      (enablePayement) => {
        this.enablePayement = enablePayement
      }
    );

  }
  seeTicket(i) {
    this.modalRef = this.modalService.show(TicketComponent, { class: 'modal-ticket' });
    this.modalRef.content.idOrder = this.orders[i].id;
  }

  getUserOrders() {
    let message = 'Erreur de serveur';
    this.ordersService.getUserOrders().subscribe(
      (data: any[]) => {
        this.orders = data;
      }
    ), (err) => {
      if (err.status == 400 && err.error.message) {
        message = err.error.message;
      }
      this.toastr.error(message, "Erreur");
    }
  }

  payer(i) {
    let id = this.orders[i].id;
    let message = 'Erreur de serveur';
    this.orders[i].loading = true;
    this.ordersService.checkOrderPayament(id).subscribe(
      () => {
        this.payerprocess(i);
      }, (err) => {
        this.alertMessage(err, i);
      })
  }

  payerprocess(i) {
    let key = this.orders[i].transactionId;
    if (key) {
      this.webSiteUsersService.getPayement(key).subscribe(
        (data: any) => {
          if (data.status == "AUTHORIZED") {
            this.router.navigate(['/confirmation-payement'], { queryParams: { trx_id: key } })
          } else {
            if (data.status == "CONFIRMED") {
              this.getUserOrders();
            } else {
              this.newPay(i);
            }
          }
        },
        (err) => {
          this.newPay(i);
        }
      )
    } else {
      this.newPay(i)
    }
  }

  newPay(i) {
    let total = this.orders[i].total;
    let id = this.orders[i].id;
    this.webSiteUsersService.getPayerId().subscribe(
      (payerId) => {
        this.initPayement(total, payerId, id, i);
      }, err => {
        this.alertMessage(err, i);
      }
    )
  }

  initPayement(total, payerId, id, i) {
    this.ordersService.getPayementData({ amount: total, payerId }).subscribe(
      (data: any) => {
        this.updateTransaction(id, data, i)
      },
      (err) => {
        this.alertMessage(err, i);
      }
    )
  }

  updateTransaction(id, data, i) {
    this.ordersService.updateOrderTransaction({ id, transaction: data.id }).subscribe(
      () => {
        window.location.href = data.redirect_url;
      },
      (err) => {
        this.alertMessage(err, i);
      }
    )
  }

  alertMessage(err, i) {
    let message = 'Erreur de serveur';
    if (err.status == 400 && err.error.message) {
      message = err.error.message;
    }
    this.toastr.error(message, "Erreur");
    this.orders[i].loading = false;
  }

}
